import {
  INode,
  IRenderContext,
  NodeStyleBase,
  RectangleNodeStyle,
  Stroke,
  SvgVisual,
  Visual,
} from '@ardoq/yfiles';
import { createSvgElement } from '@ardoq/dom-utils';
import { RepresentationData } from '@ardoq/data-model';
import { getRepresentationElement } from './utils';
import {
  HORIZONTAL_ICON_MARGIN,
  NodeDefaults,
  VERTICAL_ICON_MARGIN,
} from '../consts';

const augmentVisual = (
  node: INode,
  visual: Visual | null,
  representationData: RepresentationData,
  iconColor: string
) => {
  if (!(visual instanceof SvgVisual)) {
    return visual;
  }

  const {
    layout: { x, y },
  } = node;

  const container = createSvgElement('g');

  const representationElement = getRepresentationElement(representationData);

  representationElement.setAttribute('fill', iconColor);
  representationElement.setAttribute('x', `${x + HORIZONTAL_ICON_MARGIN}`);
  representationElement.setAttribute('y', `${y + VERTICAL_ICON_MARGIN}`);

  container.appendChild(visual.svgElement);
  container.appendChild(representationElement);

  return new SvgVisual(container);
};

class AqShapeAndIconNodeStyle extends NodeStyleBase {
  private rectangleNodeStyle: RectangleNodeStyle;
  constructor(
    private representationData: RepresentationData,
    private iconColor: string,
    private fill: string
  ) {
    super();
    this.rectangleNodeStyle = new RectangleNodeStyle({
      cornerSize: NodeDefaults.BORDER_RADIUS,
      fill: this.fill,
      stroke: Stroke.TRANSPARENT,
    });
  }

  override createVisual(context: IRenderContext, node: INode) {
    const {
      rectangleNodeStyle: { renderer },
    } = this;
    const visualCreator = renderer.getVisualCreator(
      node,
      this.rectangleNodeStyle
    );
    return augmentVisual(
      node,
      visualCreator.createVisual(context),
      this.representationData,
      this.iconColor
    );
  }
  override updateVisual(
    context: IRenderContext,
    oldVisual: Visual | null,
    node: INode
  ) {
    const {
      rectangleNodeStyle: { renderer },
    } = this;
    const visualCreator = renderer.getVisualCreator(
      node,
      this.rectangleNodeStyle
    );
    return augmentVisual(
      node,
      visualCreator.updateVisual(context, oldVisual),
      this.representationData,
      this.iconColor
    );
  }
}
export { AqShapeAndIconNodeStyle };
